import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as action from '../../../store/actions/profileActions';
import '../../../assets/css/style.css';

const VirtuesHeight = () => {
    const [height, setHeight] = useState('160');
    const profile = useSelector(state => state.profile.profile);
    const dispatch = useDispatch();
    
    const handleChange = (newValue) => {
        dispatch(action.collectProfileData({...profile, virtue: {...profile.virtue, height: newValue}}));
        setHeight(newValue);
    }

    return (
        <div className="uni-form">
            <div className="uni-slider">
                <h3><span id="uni-height-value">{height} </span>cm</h3>
                <input 
                    value={height}
                    onInput={(e) => handleChange(e.target.value)} 
                    onChange={(e) => handleChange(e.target.value)} 
                    type="range" id="uni-height" name="height" min="100" max="220" />
            </div>
        </div>
    );
};

export default VirtuesHeight;